import { gql } from '@apollo/client';

/**
 * An interface that defines the shape of the SalesforceAccountManagerV2 object.
 */
export interface SalesforceAccountManagerV2 {
  uuid: string;
  salesforceId: string;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  profileImageUrl?: string | null;
  defaultFor?: string | null;
  title?: string | null;
  isBot?: boolean | null;
}

/**
 * An interface that defines the shape of the GraphQL query result for customerAccountManager.
 */
export type CustomerAccountManagerQueryResult = {
  customerAccountManager: SalesforceAccountManagerV2;
};

/**
 * A GraphQL query that fetches the customer account manager for the authenticated customer.
 */
export const CUSTOMER_ACCOUNT_MANAGER_GQL = gql`
  query customerAccountManager {
    customerAccountManager {
      uuid
      salesforceId
      firstName
      lastName
      displayName
      email
      phoneNumber
      profileImageUrl
      defaultFor
      title
      isBot
    }
  }
`;
